<template>
  <MDBNavbar expand="lg" light container="lg" classContainer="pt-1" position="sticky" class="p-0">
    <MDBNavbarBrand tag="router-link" to="/" class="p-0"><img src="@/assets/ロゴ横型.png" class="w_logo ms-3" alt="3Dプリンティング"></MDBNavbarBrand>
    <MDBNavbarToggler
        @click="collapse1 = !collapse1"
        target="#navbarSupportedContent"
    ></MDBNavbarToggler>  
    <MDBCollapse v-model="collapse1" id="navbarSupportedContent">
      <div class="row text-end m-0 p-0">
        <div id="navbar" class="ms-auto text-end col-12 col-md-12 row m-0 p-0">
          <!-- top nav -->
          <div class="col-12 row ms-lg-auto m-0 p-0 text-center login-button">
            <a href="https://webinarweek.net/mypage/" class="col m-1 w-100" id="login_link">
              受講者用マイページ（ログイン）
            </a>
            <!-- https://webinarweek.net/webinar/entry/?thema_pid=TH_5CmHPwcc -->
            <a v-if="isLogin" href="https://webinarweek.net/webinar/entry/?thema_pid=TH_5CmHPwcc" target="_blank" class="col m-1 w-100" id="signup_link">
              受講者登録は こちら
            </a>
            <div v-else style="color: #C4231A" class="col m-0 p-0 w-100" >ようこそ、{{ member_info.name }}さん</div>
          </div>

          <!-- bottom nav -->
          <div id="nav_button" class="col-12 row">
        <ul class="inline-list m-0 py-1">
          <li><router-link to="/">イベントトップ</router-link></li>
          <li><router-link to="/#timetable">タイムテーブル</router-link></li>
          <!-- <li><router-link to="/info_list">お知らせ一覧</router-link></li> -->
          <!-- <li><router-link to="/company_list">参加企業一覧</router-link></li> -->
          <li><router-link to="/#exhibiting-companies">参加企業から探す</router-link></li>
          <li><router-link to="/faq">よくある質問</router-link></li>
          <li><a href="https://webinarweek.net/top/" class="router-link-active router-link-exact-active" aria-current="page">Webinar Weekトップ</a>
            <!-- <router-link to="">Webinar Weekトップ</router-link></li> -->
          </li>
          <li><a href="https://webinarweek.net/top/" class="img-link" id="andon_link"><img src="@/assets/白ロゴ.png" class="ps-3" alt="andon"></a></li>
        </ul>
<!--             
            <div class="col-12 col-lg-1 p-0 nav_button_top d-flex align-items-end justify-content-end justify-content-lg-start">
              <router-link to="/">トップ</router-link>
            </div>

            <div class="col-12 col-lg-3 p-0 d-flex align-items-end justify-content-end justify-content-lg-center">
              <router-link to="/#timetable">タイムテーブル</router-link>
            </div>
            
            <div class="col-12 col-lg-2 p-0 d-flex align-items-end justify-content-end justify-content-lg-center">
              <router-link to="/info_list">お知らせ⼀覧</router-link>
            </div>
            
            <div class="col-12 col-lg-2 p-0 d-flex align-items-end justify-content-end justify-content-lg-center">
              <router-link to="/company_list">参加企業一覧</router-link>
            </div>

            <div class="col-12 col-lg-2 p-0 text-end d-flex align-items-end justify-content-end">
              <router-link to="/faq">よくある質問</router-link>
            </div>

            <div class="col-12 col-lg-2 p-0 text-end">
              <a href="https://and-on.net/" class="img-link" id="andon_link"><img src="@/assets/rogo_andon.png" class="ps-1" alt="andon" style="width:130px;"></a>
            </div> -->



          </div>
        </div>
      </div>
    </MDBCollapse>
  </MDBNavbar>
</template>

<script>
import {
  MDBNavbar,
  MDBNavbarToggler,
  MDBNavbarBrand,
  MDBCollapse,
} from 'mdb-vue-ui-kit';
import {ref} from 'vue';
import _ from 'lodash';
import {Api, Http} from '@/utiles/ApiConnect';

export default {
  data: function() {
    return {
      member_info: [],
    };
  },

  components: {
    MDBNavbar,
    MDBNavbarToggler,
    MDBNavbarBrand,
    MDBCollapse,
  },

  computed: {
    isLogin() {
      return _.isEmpty(this.member_info);
    },
  },

  setup() {
    const collapse1 = ref(false);
    return {
      collapse1,
    };
  },

  mounted: function() {
    this.getMemberInfo();
    this.$nextTick(function() {
      $('a').on('click', function() {
        const $target = $('button[aria-controls="#navbarSupportedContent"]')
        if ($target.attr('aria-expanded') == 'true') {
          $target.trigger('click')
        }
      });
    });
  },

  methods: {
    // ユーザー情報取得
    getMemberInfo: function() {
      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Member.Info',
          // 引数の指定
          {},
      )
          // 実行結果の取得
          .done(function(result) {
            this.member_info = result.data;
          }.bind(this));
    }
  },
};
</script>

<style lang="scss">
@import "./node_modules/mdb-vue-ui-kit/src/scss/index.free.scss";
.inline-list{
  display: inline;
  @include media-breakpoint-down(md) {
    display: block;
  }
  padding: 0px !important;
}
.inline-list li{
  display: inline;
  margin: 0px 15px 0px 15px;
  @include media-breakpoint-down(md) {
    display: block;
    margin: 0px;
  }
}
.login-button{
  max-width:85% !important;
  @include media-breakpoint-down(md) {
    max-width:100% !important;
  }
}
.lang{
  a:hover{
    border: none;
  }
  position: absolute;
  top: 10px;
  right: 0;
  z-index: 99;
  img{
    width: 30px;
    height: auto;
  }
  @include media-breakpoint-down(md) {
    position: relative;
  }
}
.navbar {
  background-color:  var(--primary-05);
  padding: 0;
}
.w_logo{
  height: 80px;
  width: auto;
}
.navbar-toggler{
    color:white !important;
}

#navbarSupportedContent {
  justify-content: flex-end !important;  
  #navbar{
      // width: 50%;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }  
  .nav_button_top{
    text-align: left;
    @include media-breakpoint-down(md) {
      text-align: right;
    }
  }  
  #nav_button{
    @include media-breakpoint-down(md) {
      padding-right: 1rem;
    }
  }
  #nav_button a:not(.img-link) {
      color: #ffffff;
      text-decoration: none;
      position: relative;
      transition: .3s;

      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: '';
        width: 0;
        height: 1px;
        transition: .3s;
        background-color: #fff;
      }

      &:hover::after {
        width: 100%;
      }
    }
  a {
    color: white;
    cursor: pointer;
    transition: all ease 0.3s;
  }

  .img-link {
    transform: scale(1.1);
  }

  #exhibitor_login {
    border: 1px solid #fff;
    padding: 2px 6px;
    color: #fff;
    display: inline-block;
  }

  #andon_link {
    width: 160px;
    display: inline-block;
    img{
      width: 90%;
    }
  }

  #signup_link {
    background-color: var(--transparant);
    color: white;
    border: solid white 2px;
    align-items: center;
    padding: 2px 10px;
    display: inline-block;
    @include media-breakpoint-down(lg) {
      margin: 0.4rem auto;
      width: 270px;
    }    
    cursor: pointer;
    box-shadow: 0px 0px 1px 2px rgba(255,255,255,0);
    transition: all 0.25s ease;
    &:hover {
      box-shadow: 0px 0px 1px 2px white;
      border: solid var(--secondary) 2px;
      a {
        color: var(--secondary);
      }
    }
    &:active {
      box-shadow: 0px 0px 1px 2px white;
    }
  }

  #login_link {
    background-color: var(--secondary);
    color: white;
    // border: solid var(--secondary) 2px;
    padding: 2px 10px !important;
    display: inline-block;
    @include media-breakpoint-down(lg) {
      margin: 0.4rem auto;
      width: 270px;
    }
    cursor: pointer;
    box-shadow: inset 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
    transition: all 0.25s ease;
    &:hover {
      box-shadow: inset 0px 0px 1px 2px var(--secondary);
    }
    &:active {
      
      box-shadow: inset 0px 0px 1px 2px var(--secondary);
    }
  }

  .link-area {
    @include media-breakpoint-up(lg) {
      max-width: 440px;
      width: 60%;
    }
  }

  @include media-breakpoint-down(lg) {
    .d-flex div {
      margin-bottom: 20px;
    }
    a {
      color: #fff;
    }
  }
}

</style>